// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__XXj-R","smallPrint":"footer_smallPrint__8dMdY"};